import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {SlideDown} from 'react-slidedown'
import { Link as ScrollLink } from 'react-scroll'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  ComcastPetitionLetter,
  PetitionForm,
} from '../../components'
import Styles from './ComcastPetitionLanding.css'


@CSSModules(Styles, {allowMultiple:true})
export default class ComcastPetitionLanding extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'Comcast: Stop Investing Employee Savings into Prisons',
      description: 'Join As You Sow to urge Comcast management to offer a prison-free default retirement fund.',
      url: config.domain + config.routes.comcastPetitionLanding,
      mobileBannerFixed: true,
      showLetter: false,
      showFullPetition: false
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const { title, description, url } = this.state

    const headlineImg = require('../../../static/images/handsbars-circle.jpg')

    const mobileBannerStyle = this.state.mobileBannerFixed ?
      'mobile-fixed' :
      'mobile-relative'

    return (
      <div styleName='page'>
        {
          container.helmet(
            title,
            description,
            url
          )
        }
        <ContainerDivs>

          <div styleName='hl-wrap'>
            { /* LEFT COLUMN */ }
            <div>
              <div styleName='hl'>
                {title}
              </div>
              <img
                src={headlineImg}
                alt='Comcast: Stop Investing Employee Savings into Prisons'
                styleName='hl-img-sm visible-xs'
              />
              <div styleName='copy'>
                <p>
                  Comcast is currently investing its employees’ savings into companies profiting from the prison industrial complex – which includes for-profit prisons, companies profiting from exploitative prison labor, and immigration jails.
                </p>

                <p>
                  Comcast has made public commitments to help address structural racism, including a $100 million plan to fight injustice and inequality. But most employees at Comcast have no idea that their retirement plan is invested in companies involved in mass incarceration, immigrant policing and surveillance, or the border industry.
                </p>

                <p>
                  These firms are known to lobby for harsher policing and sentencing of non-violent crimes that impact poor communities, immigrants, and people of color. If this isn't your idea of how Comcast employees should invest their hard-earned money, you can join thousands of other concerned citizens to call on Comcast to help direct investments away from the prison and border industries.
                </p>

                <p styleName='scroll-link'>
                  <ScrollLink
                    activeClass='active-scroll-link'
                    to='section1'
                    spy
                    smooth
                    offset={-70}
                    duration={500}
                  >
                    <b>Join As You Sow to urge Comcast management to live up to their public commitments by offering a prison-free default retirement fund.</b>
                  </ScrollLink>
                </p>

                <div styleName='hidden-xs'>
                  <p>
                    Mass incarceration is a manifestation of racist policy. Companies like Comcast that have the prison industrial complex embedded in their 401(k) plans are forcing their employees to invest in racial injustice. It’s time for employees and society at large to make sure that investments stop funding private prisons and other companies profiting from economic systems of oppression and exploitation.
                  </p>

                  <p styleName='scroll-link'>
                    <ScrollLink
                      activeClass='active-scroll-link'
                      to='section1'
                      spy
                      smooth
                      offset={-70}
                      duration={500}
                    >
                      <b>Start by signing this petition to Comcast’s management saying that it’s time to stop funding the prison industrial complex.</b>
                    </ScrollLink>
                  </p>

                  { /* PETITION LETTER */ }
                  <ComcastPetitionLetter/>
                </div>

                { /* AFTER PETITION LINKS */ }
                <div styleName='after-petition-links hidden-xs'>
                  <div styleName='after-petition-links-lbl'>
                    More
                  </div>
                  <div styleName='after-petition-links-div'>
                    <Link
                      to={config.routes.plans + '/comcast'}
                      title='Comcast 401(k) scorecard'
                      xstrong
                    >
                      See the scorecard for the Comcast 401(k)<LinkIcon/>
                    </Link>
                  </div>
                  <div styleName='after-petition-links-div'>
                    <Link
                      to={config.routes.eduCenter}
                      title='Action center'
                      xstrong
                    >
                      Action center<LinkIcon/>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            { /* RIGHT COLUMN */ }
            <div styleName='hl-img-wrap'>
              <div styleName='petition-widget-wrap'>
                <img
                  src={headlineImg}
                  alt='Comcast: Stop Investing Employee Savings into Prisons'
                  styleName='hl-img hidden-xs'
                />
                <div styleName={'sticky-widget ' + mobileBannerStyle}>
                  <div id='section1'/>
                  <div styleName='sticky-widget-close visible-xs'>
                    <div
                      onClick={
                        () => {
                          //
                          this.setState({
                            mobileBannerFixed: false
                          })
                        }
                      }
                    >
                      <LinkIcon nospace faclass='fa-close'/>
                    </div>
                  </div>
                  <h2 styleName='thumbs-up-top-label'>
                    Comcast: Stop Investing Employee Savings into Prisons
                  </h2>
                  <div styleName='c'>
                    <h3 styleName='thumbs-up-top-label-2'>
                      Sign this petition
                    </h3>
                  </div>
                  <PetitionForm
                    petitionConfig={config.petitionConfigs.comcast}
                  />
                </div>
              </div>
            </div>
          </div>

          <div styleName='visible-xs'>
            <div
              styleName='show-more-button'
              title='Learn more'
              onClick={
                (e)=>{
                  this.setState({showFullPetition: !this.state.showFullPetition})
                }
              }
            >
              Learn more<LinkIcon faclass={
                this.state.showFullPetition ?
                  'fa-angle-double-up' :
                  'fa-angle-double-down'
              }/>
            </div>
            <SlideDown>
              {
                this.state.showFullPetition ?
                  (
                    <div styleName='copy'>
                      <p>
                        Mass incarceration is a manifestation of racist policy. Companies like Comcast that have the prison industrial complex embedded in their 401(k) plans are forcing their employees to invest in racial injustice. It’s time for employees and society at large to make sure that investments stop funding private prisons and other companies profiting from economic systems of oppression and exploitation.
                      </p>

                      <p styleName='scroll-link'>
                        <ScrollLink
                          activeClass='active-scroll-link'
                          to='section1'
                          spy
                          smooth
                          offset={-70}
                          duration={500}
                        >
                          <b>Start by signing this petition to Comcast’s management saying that it’s time to stop funding the prison industrial complex.</b>
                        </ScrollLink>
                      </p>

                      { /* PETITION LETTER */ }
                      <ComcastPetitionLetter/>
                    </div>
                  ) :
                  null
              }
            </SlideDown>
          </div>

          { /* AFTER PETITION LINKS */ }
          <div styleName='after-petition-links visible-xs'>
            <div styleName='after-petition-links-lbl'>
              More
            </div>
            <div styleName='after-petition-links-div'>
              <Link
                to={config.routes.plans + '/comcast'}
                title='Comcast 401(k) scorecard'
                xstrong
              >
                See the scorecard for the Comcast 401(k)<LinkIcon/>
              </Link>
            </div>
            <div styleName='after-petition-links-div'>
              <Link
                to={config.routes.eduCenter}
                title='Action center'
                xstrong
              >
                Action center<LinkIcon/>
              </Link>
            </div>
          </div>

        </ContainerDivs>

        <br/>
        <br/>
        <br/>
      </div>
    )
  }
}
